module.exports = __webpack_public_path__ + "static/media/tier-6.bec3570a.jpg";